import { render, staticRenderFns } from "./ProjectCustomerForm.vue?vue&type=template&id=705cdfcc&scoped=true&"
import script from "./ProjectCustomerForm.vue?vue&type=script&lang=ts&"
export * from "./ProjectCustomerForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectCustomerForm.vue?vue&type=style&index=0&id=705cdfcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705cdfcc",
  null
  
)

export default component.exports